module.exports = __webpack_public_path__ + "assets/images/edge.4dd307eed9d0baef2796c66bc3c1b91a.png";